import axios from "axios";
import { env } from "../env";
import { handleError } from "../utils/errorhandler";
import { tokenService } from "./tokenService";

// Determine which API URL to use
const getBaseURL = () => {
  // Check if running on localhost
  const isLocal = globalThis.location.hostname === 'localhost' || 
                  globalThis.location.hostname === '127.0.0.1';
  
  // Use local API URL if available and running locally
  if (isLocal && env.REACT_APP_LOCAL_API_URL) {
    return env.REACT_APP_LOCAL_API_URL;
  }
  
  return env.REACT_APP_API_URL;
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  },
});

// Track if we're already redirecting to prevent loops
let isRedirecting = false;

// Add request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add JWT token to Authorization header if it exists
    const token = tokenService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔐 Request interceptor: Added token to request');
    } else {
      console.log('⚠️ Request interceptor: No token available');
    }

    console.log(
      "===============Request===========\n",
      `URL: ${config.baseURL}${config.url}\n`,
      `Method: ${config.method}\n`,
      `Authorization: ${config.headers.Authorization ? 'Bearer ***' : 'None'}\n`,
      `Request Body: ${JSON.stringify(config.data)}`
    );
    return config;
  },
  (error) => {
    console.error('❌ Request interceptor error:', error);
    return Promise.reject(new Error(error.message));
  }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log("========Response=========", response);
    return response;
  },
  (error) => {
    console.error('❌ Response interceptor error:', error.response?.status);
    
    // Handle 401 Unauthorized - token expired or invalid
    // Skip redirect if already on login page (let the login thunk handle the error)
    if (error.response?.status === 401 && !isRedirecting && window.location.pathname !== '/login') {
      console.log('🚫 401 Unauthorized: Clearing token and redirecting to login');
      isRedirecting = true;
      
      // Clear invalid token
      tokenService.removeToken();
      
      // Redirect to login page
      globalThis.location.href = '/login';
      
      // Reset flag after a delay
      setTimeout(() => {
        isRedirecting = false;
      }, 1000);
    }

    const handledError = handleError(error);
    return Promise.reject(handledError);
  }
);

export { axiosInstance };
